import { fetcher } from '@commenda/utils';
import { IContentLibraryResponse } from './types';

export async function fetchContentLibrary(
  contentId: string,
  inputs: Record<string, unknown>,
  token?: string
): Promise<{
  success: boolean;
  data?: IContentLibraryResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `content-library/${contentId}`,
      { method: 'POST', body: inputs },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || `Failed to fetch content: ${contentId}`,
      };
    }

    const data: IContentLibraryResponse = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error',
    };
  }
}
